import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import { useTranslation, Trans } from 'react-i18next';
import { Rating } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core';
import StarRoundedIcon from '@material-ui/icons/StarRounded';

import { Box, Flex, Text, Formik } from 'Components/Base';

const { MuiInput } = Formik;

const useStyles = makeStyles({
  icon: ({ breakpoints }) => ({
    margin: '0px 8px',
    fontSize: '65px',
    [`@media screen and (max-width: ${breakpoints[0]})`]: {
      fontSize: '42px',
      margin: '0px 4px',
    },
  }),
  iconFilled: ({ colors }) => ({
    fill: colors.primary,
  }),
  iconEmpty: ({ colors }) => ({
    color: colors.notiGrey.grey2,
  }),
});

const ReviewRatingFeedback = ({ onChangeRating, ratingValue, onChangeFeedback, feedbackValue }) => {
  const { t } = useTranslation('classroom');
  const { colors, spaces, breakpoints } = useTheme();
  const classes = useStyles({ colors, spaces, breakpoints });

  const renderRatingText = () => {
    switch (ratingValue) {
      case 1:
        return t('COURSE_REVIEW.RATING_STAR.TERRIBLE');
      case 2:
        return t('COURSE_REVIEW.RATING_STAR.POOR');
      case 3:
        return t('COURSE_REVIEW.RATING_STAR.AVERAGE');
      case 4:
        return t('COURSE_REVIEW.RATING_STAR.GOOD');
      case 5:
        return t('COURSE_REVIEW.RATING_STAR.EXCELLENT');
      default:
        return '';
    }
  };

  return (
    <Flex flexDirection={'column'} alignItems={'center'}>
      <Text fontWeight={'medium'} textAlign={'center'}>
        <Trans defaults={t('COURSE_REVIEW.RATING_TITLE')} components={[<br key="1st" />]} />
      </Text>
      <Box pt={7} />
      <Rating
        name={'rating'}
        classes={classes}
        value={ratingValue}
        icon={<StarRoundedIcon fontSize="inherit" />}
        onChange={onChangeRating}
      />
      {ratingValue !== null && (
        <Text textStyle={'body2'} fontWeight={'normal'} mt={4}>
          {renderRatingText()}
        </Text>
      )}
      <Box pt={7} />
      <MuiInput.TextArea
        rows={4}
        rowsMax={4}
        name="feedback"
        value={feedbackValue}
        placeholder={t('COURSE_REVIEW.RATING_PLACEHOLDER')}
        onChange={onChangeFeedback}
      />
      <Box pt={7} />
      <Text textStyle={'body2'} color={'greyscale.grey3'}>
        <Trans defaults={t('COURSE_REVIEW.RATING_CAPTION')} components={[<br key="1st" />]} />
      </Text>
    </Flex>
  );
};

ReviewRatingFeedback.propTypes = {
  onChangeRating: PropTypes.func,
  onChangeFeedback: PropTypes.func,
};

export default ReviewRatingFeedback;
